var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-box"},[_c('Icon'),_vm._v(" "),_c('Nav'),_vm._v(" "),_c('router-view',{on:{"changeLevels":_vm.changeLevels}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }